module.exports = __webpack_public_path__ + "static/content-logos-85b76c3862263c72a2f1c8d20cac82d7.png";